<template>
  <div class="page flex-col">
    <div class="group2 flex-col">
      <img
        class="pic1"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb192c423ef2f348e34b47c0db6f4adafd9285f069bfc9503b1e453bcefc10752"
      />
    </div>
    <div class="group3 flex-col"></div>
    <div class="group4 flex-col">
      <div class="layer1 flex-col">
        <div class="mod6 flex-row justify-between">
          <img
            class="img1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd9564eb4631590f5fdf645b889c5a10edce5780d43ed81b7ba2d9cb367bd5e4b"
          />
          <img
            class="img2"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng050c92ae755ff5172fd7c061ef6654cb5044caf656b62954cb406d5ac2950e48"
          />
        </div>
        <img
          class="pic2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng69742cfce63fb38802dbad4cbb24e9efd4dcd8a773f460851f53952729ee8870"
        />
        <div class="mod7 flex-row justify-between">
          <img
            class="img3"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng284704c7aba8b4576c1711106cf0eb4973c3911aec5877249c9220ee27479a92"
          />
          <img
            class="pic3"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng62e22120220bbce1fcbbe587b0c1a38b7f595cf40b1a0afa41974666c62250d8"
          />
        </div>
        <div class="mod8 flex-col"></div>
      </div>
      <img
        class="pic4"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngeb3c8561d83730bea70c13873ba9358b9427b55b3d94ac67b2b1a32201296cd9"
      />
      <img
        class="img4"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng52c48a5f05c73f4ac22e1ec9eba2d7ff9e297dfc2a8fdb0cb90dbfe188424756"
      />
    </div>
  </div>
</template>
<script>


export default {
  data () {
    return {
      constants: {},
    }
  },
  methods: {},
};
</script>
<style scoped>
@import url(../pages/common.css);
@import url(../pages/index.css);
html {
  font-size: 37.5px;
}

.page {
  position: relative;
  width: 38.4rem;
  height: 45.547rem;
  background-color: rgba(242, 238, 228, 1);
  overflow: hidden;
  margin: 0 auto;
}

.group1 {
  width: 38.4rem;
  height: 22.187rem;
}

.outer1 {
  height: 2.08rem;
  background-color: rgba(255, 255, 255, 1);
  width: 38.4rem;
  padding: 0.507rem 0 0 2.987rem;
}

.mod1 {
  width: 32.214rem;
  height: 1.307rem;
}

.mod2 {
  width: 4.534rem;
  height: 1.307rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4763fecae4f3dbd33fedecbd4a2e0fc03f75b4cd8e9d4e000fe793b5c88589d4)
    0.187rem 0rem no-repeat;
  background-size: 4.347rem 1.334rem;
}

.txt1 {
  width: 0.88rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 4.08rem;
}

.mod3 {
  height: 0.827rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngde1affade5c2e666edec9c444d5aefef0a47db75485b18d5ca2e15fd7018c5d9)
    100% no-repeat;
  width: 3.467rem;
  margin: 0.134rem 0 0 0.587rem;
  padding: 0.16rem 0 0 0.96rem;
}

.info1 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.info2 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.747rem;
}

.txt2 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.547rem;
}

.txt3 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.547rem;
}

.mod4 {
  width: 0.427rem;
  height: 0.587rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5618ba96d6e45c5af5d14cae1dcfca8615fc726c6816559d10f2f2d325c1d304)
    100% no-repeat;
  margin: 0.24rem 0 0 7.36rem;
}

.txt4 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.214rem;
}

.mod5 {
  width: 0.027rem;
  height: 0.427rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng292e16e315659a9700abfa430c040d1419bc4573dc009e320d08121fccd7eb1f)
    0rem 0rem no-repeat;
  background-size: 0.027rem 0.454rem;
  margin: 0.347rem 0 0 0.294rem;
}

.info3 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.294rem;
}

.outer2 {
  width: 38.4rem;
  height: 8.134rem;
  background-color: rgba(248, 247, 242, 1);
  margin-top: 11.974rem;
}

.group2 {
  z-index: 32;
  position: absolute;
  left: 0;
  /* top: 2.08rem; */
  width: 38.4rem;
  height: 12rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngbeae9dfffa4d88325f1d16ffefaf2647fb674cebf85d14ddb3ecd02e634fa77a)
    100% no-repeat;
}

.pic1 {
  z-index: 33;
  position: absolute;
  left: 0;
  top: 0;
  width: 38.4rem;
  height: 12rem;
  margin: 0;
}

.group3 {
  z-index: 26;
  position: absolute;
  left: 0;
  top: 12.054rem;
  width: 38.4rem;
  height: 12.294rem;
  background-color: rgba(242, 238, 228, 1);
}

.group4 {
  z-index: 28;
  height: 29.654rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng81027e3bb8007c2b85fa6d2ac980f056d229ebee2e00ed68b02cea4531c74206)
    100% no-repeat;
  padding-top: 0.8rem;
  width: 38.4rem;
  position: absolute;
  left: 0;
  top: 12.054rem;
}

.layer1 {
  width: 38.4rem;
  height: 28.694rem;
}

.mod6 {
  width: 26.667rem;
  height: 8.534rem;
  margin-left: 5.867rem;
}

.img1 {
  width: 16rem;
  height: 8.534rem;
}

.img2 {
  width: 10.134rem;
  height: 8.534rem;
}

.pic2 {
  width: 26.64rem;
  height: 8.427rem;
  margin: 0.534rem 0 0 5.867rem;
}

.mod7 {
  width: 26.64rem;
  height: 8.587rem;
  margin: 0.507rem 0 0 5.867rem;
}

.img3 {
  width: 16rem;
  height: 8.56rem;
  margin-top: 0.027rem;
}

.pic3 {
  width: 10.134rem;
  height: 8.56rem;
}

.mod8 {
  width: 38.4rem;
  height: 0.134rem;
  background-color: rgba(170, 29, 31, 1);
  margin-top: 1.974rem;
}

.pic4 {
  z-index: 29;
  position: absolute;
  left: 0;
  top: 15.014rem;
  width: 29.76rem;
  height: 14.64rem;
}

.img4 {
  z-index: 30;
  position: absolute;
  left: 14.4rem;
  top: 15.014rem;
  width: 24rem;
  height: 14.64rem;
}

.group5 {
  z-index: 36;
  height: 2rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2dc70e2dd957c588ff9bfdb344f8935d1e22f4b76f2bdd7091a344d1f294119c)
    100% no-repeat;
  width: 38.4rem;
  position: absolute;
  left: 0;
  top: 41.547rem;
  padding: 0.747rem 0 0 16.187rem;
}

.word1 {
  z-index: 39;
  position: static;
  left: 16.187rem;
  top: 44.294rem;
  width: 6.054rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.373rem;
  font-family: PingFangTC-Regular;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.pic5 {
  z-index: 37;
  position: absolute;
  left: 0;
  top: 0;
  width: 38.4rem;
  height: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/show.vue